import type { StatusPosicao } from '@wms/shared';
import { ESTILO_STATUS, STATUS_VISIVEIS } from '@/lib/status';
import { cn, numero } from '@/lib/utils';

/**
 * Legenda sempre visível (doc 06, regra 2) e clicável: cada item é também o
 * filtro daquele status. Só entram os quatro estados que a API produz —
 * "parcial" e "bloqueada" não aparecem porque não acontecem.
 */
export function Legenda({
  contagem,
  ativo,
  aoAlternar,
  className,
}: {
  contagem: Record<StatusPosicao, number>;
  ativo: StatusPosicao | null;
  aoAlternar: (status: StatusPosicao) => void;
  className?: string | undefined;
}): JSX.Element {
  return (
    <ul className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {STATUS_VISIVEIS.map((status) => {
        const estilo = ESTILO_STATUS[status];
        const selecionado = ativo === status;
        return (
          <li key={status}>
            <button
              type="button"
              onClick={() => aoAlternar(status)}
              aria-pressed={selecionado}
              title={estilo.descricao}
              className={cn(
                'flex min-h-[36px] items-center gap-2 rounded-full border px-3 text-xs font-medium shadow-xs transition-all',
                estilo.classeBadge,
                selecionado
                  ? 'ring-2 ring-primaria ring-offset-1 ring-offset-fundo'
                  : 'opacity-85 hover:-translate-y-px hover:opacity-100',
              )}
            >
              <span aria-hidden className="font-mono text-sm leading-none">
                {estilo.glifo}
              </span>
              <span className="font-medium">{estilo.rotulo}</span>
              <span className="tabular opacity-80">{numero(contagem[status])}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export function contarStatus(
  posicoes: readonly { status: StatusPosicao }[],
): Record<StatusPosicao, number> {
  const contagem: Record<StatusPosicao, number> = {
    livre: 0,
    parcial: 0,
    ocupada: 0,
    bloqueada: 0,
    divergencia: 0,
    indisponivel: 0,
  };
  for (const p of posicoes) contagem[p.status] += 1;
  return contagem;
}
